import { Button, Stack, Tooltip, Typography } from '@mui/material'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'
import Image from 'next/image'
import { RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { track } from '@omnea-app/fe-analytics/useAnalytics'
import { AiFilterDialog } from './components/AIFilterDialog'

interface AiFilterCreatorProps {
  tableName: string
  apiRef: RefObject<GridApiPremium>
  disabled?: boolean
}

export const AiFilterCreator: React.FC<AiFilterCreatorProps> = ({ apiRef, tableName, disabled }) => {
  const { t } = useTranslation('common')
  const [isAiFilterDialogOpen, setAIFilterOpen] = useState(false)
  function handleOpenDialog() {
    setAIFilterOpen(true)
    track('AIFilterClicked', {
      tableName: tableName.toLowerCase(),
    })
  }

  return (
    <>
      <Tooltip title={t('table.table-toolbar.ai-filter-button-tooltip')}>
        <Button
          color="secondary"
          disabled={disabled}
          onClick={handleOpenDialog}
          sx={{ textTransform: 'none', '&:hover': { bgcolor: 'bg.interactive.hover' } }}
          startIcon={
            <Stack direction="row" gap="2px" sx={{ color: 'text.muted', justifyContent: 'center', alignItems: 'center' }}>
              <Image alt="openai" src="/app/assets/ai-filter-logo.svg" width={16} height={16} />
              <Typography sx={{ m: 0, p: 0, ml: '1px' }} variant="body-medium">
                {t('table.table-toolbar.ai-filter-button-label')}
              </Typography>
            </Stack>
          }
        />
      </Tooltip>
      <AiFilterDialog open={isAiFilterDialogOpen} onClose={() => setAIFilterOpen(false)} apiRef={apiRef} tableName={tableName} />
    </>
  )
}
